import { createAction, props } from '@ngrx/store';
export const setModelPortfolioToRefresh = createAction('[Model Portfolio to Refresh] Set Model Portfolio to Refresh', props());
export const removeModelPortfolioToRefresh = createAction('[Model Portfolio to Refresh] Remove Model Portfolio to Refresh');
